/**
 * @param {string} query
 * @param {string} text
 */
export function matchesCatalogSearch(query, text) {
  const needle = query.trim().toLowerCase()
  if (!needle) return true
  return String(text ?? '').toLowerCase().includes(needle)
}

/**
 * @template T
 * @param {T[]} items
 * @param {string} query
 * @param {(item: T) => string} getLabel
 */
export function filterCatalogItems(items, query, getLabel) {
  if (!query.trim()) return items
  return items.filter((item) => matchesCatalogSearch(query, getLabel(item)))
}
